import { atom } from 'jotai';
import { GlobalSearchPopupRef } from '~/components/ui/globalSearch/GlobalSearchPopup';

export const globalSearchRefAtom = atom<GlobalSearchPopupRef | null>(null);
export const globalSearchStringAtom = atom('');
